import { t } from "ttag";

import * as Urls from "metabase/lib/urls";

import Link from "../../../core/components/Link";

import { NewButton, NewButtonText } from "./NewQuestionButton.styled";

/**
 * A simplified "new" button that only creates a new question.
 * Similar to "../NewItemButton" but without the dropdown menu.
 */
const NewQuestionButton = () => {
  return (
    <NewButton
      key="new-question-button"
      primary
      icon="insight"
      iconSize={14}
      data-testid="header-new-question-button"
      data-metabase-event="AppBar;New Question Click"
      as={Link}
      to={Urls.newQuestion({
        mode: "notebook",
        creationType: "custom_question",
      })}
    >
      <NewButtonText>{t`New Question`}</NewButtonText>
    </NewButton>
  );
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default NewQuestionButton;
